module.exports = __webpack_public_path__ + "static/wearit-49a65ee0a50f49e0ac1e331bd055b122.svg";